<template>
  <v-row dense justify="center">
    <v-col cols="12" class="title d-flex align-center">
      <v-icon color="secondary" left>mdi-clipboard-text</v-icon> Eventos
    </v-col>
    <template v-if="events && events.length">
      <v-col cols="12" md="6" v-for="event in events" :key="`event-${event.id}`">
        <v-card outlined flat class="fill-height">
          <v-card-subtitle class="font-weight-black black--text">
            <v-icon color="secondary" left>mdi-clipboard-text</v-icon> {{ event.name }}
          </v-card-subtitle>
          <v-card-text class="pb-0">
            <template v-if="event.has_unlimited_places">
              Vagas Ilimitadas
            </template>
            <template v-else>
              Total de Vagas: {{ event.total_places }}, Restantes: {{ event.total_places_remaining }}
            </template>
          </v-card-text>
          <v-card-text class="pt-0">
            <v-chip outlined v-for="group in event.groups" :key="`group-${group.id}`" class="mr-2 mt-2">
              {{ group.name }}
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn block depressed :to="{ name: 'ambienteAluno.events.eventSessions', params: { eventId: event.id } }">
              Ver Sessões Deste Evento
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12">
        <v-alert type="info" border="left" colored-border>Não há eventos disponíveis</v-alert>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { Event } from '@/services/resources'

export default {
  name: 'Annotations',
  data () {
    return {
      events: null
    }
  },
  mounted () {
    Event.events()
      .then(response => {
        this.events = response.data.events
      }).catch((error) => {
        console.log('responseError', error)
        this.$toasted.global.error({ message: error.statusText })
      })
  }
}
</script>

<style>
.annotation img {
  max-width: 100% !important;
}
</style>
